export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000/api'
export const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || 'http://localhost:3000'
export const COUNTER_ENDPOINT = process.env.REACT_APP_COUNTER_ENDPOINT || 'http://localhost:7000';
export const MOBILE_WIDTH = 768
export const NODE_ENV = process.env.NODE_ENV || 'development'

export const SEATMAP_PUBLIC_KEY = process.env.REACT_APP_SEATMAP_PUBLIC_KEY || "254c6739-6260-4e79-80b3-ca5b27611929"
export const SEATMAP_LIB_URL = "https://booking.seatmap.pro/static/seatmap-booking-renderer.js"
export const SEATMAP_ENVIRONMENT = 'production'

export const YANDEX_METRIKA_ACCOUNT_ID = Number.parseInt(process.env.REACT_APP_YANDEX_METRIKA_ACCOUNT_ID) || null
export const MAX_TICKETS_IN_ORDER = 10

export const PERSONAL_DATA_PROCESSING_CONSENT_URL = 'https://kudago.com/pages/soglasie-tickets/'
